import WebinarsPage from './WebinarsPage';
import WebinarFullView from './WebinarFullView';
import ModuleView from './WebinarModuleView';
import WebinarSeriesPage from './WebinarSeriesPage';

export {
    WebinarsPage,
    WebinarFullView,
    WebinarSeriesPage,
    ModuleView
}


// WEBPACK FOOTER //
// src/client/components/site/features/training/webinars/pages/index.js